module.exports = __webpack_public_path__ + "static/media/wave-grc-1.2ead0212.svg";